import apiClient from '@src/api/clients';

const OPTIONS_URL = 'app1/ad-builder/options/';
const BUILD_URL = 'app1/ad-builder/build/';
const HISTORY_URL = 'app1/ad-builder/history/';

export const listAdNameOptions = (optionType) =>
  apiClient.request({
    url: OPTIONS_URL,
    method: 'GET',
    payload: optionType ? { type: optionType } : {},
  });

export const createAdNameOption = (payload) =>
  apiClient.request({
    url: OPTIONS_URL,
    method: 'POST',
    payload,
  });

export const deleteAdNameOption = (id) =>
  apiClient.request({
    url: `${OPTIONS_URL}${id}/`,
    method: 'DELETE',
  });

export const buildAdName = (payload) =>
  apiClient.request({
    url: BUILD_URL,
    method: 'POST',
    payload,
  });

export const listAdNameHistory = (params = {}) =>
  apiClient.request({
    url: HISTORY_URL,
    method: 'GET',
    payload: params,
  });

export default {
  listAdNameOptions,
  createAdNameOption,
  deleteAdNameOption,
  buildAdName,
  listAdNameHistory,
};
